<lms-breadcrumb
  [crumbs]="[{ label: 'nouns.licenseReport', icon: 'glicon-file-licenses', route: '.' }]"
></lms-breadcrumb>

<div>
  <lms-toolbar> </lms-toolbar>
  <lms-license-log [license]="license" [course]="course"></lms-license-log>
</div>
